import { gql } from 'graphql.macro';

export const enableEInvoicingTemplate = gql`
    mutation enableEInvoicing {
        enableEInvoicing {
            enabled
            enabledAt
            migrated
            requirements
            canEnable
        }
    }
`;

export const checkCustomerEInvoicingTemplate = gql`
    mutation checkCustomerEInvoicing($clientId: MongoDbObjectId!) {
        checkCustomerEInvoicing(clientId: $clientId) {
            status
            receiverPartyId
            organizationNumber
            countryCode
            gln
            checkedAt
            invite {
                id
                type
                email
                status
                sentAt
            }
        }
    }
`;

export const sendCustomerEInvoiceInviteTemplate = gql`
    mutation sendCustomerEInvoiceInvite($clientId: MongoDbObjectId!, $email: String!, $message: String) {
        sendCustomerEInvoiceInvite(clientId: $clientId, email: $email, message: $message) {
            status
            receiverPartyId
            organizationNumber
            countryCode
            gln
            checkedAt
            invite {
                id
                type
                email
                status
                sentAt
            }
        }
    }
`;
